import React from "react";

import { connect } from 'react-redux';
import Dashboard from "./Dashboard";
import ClientDashboard from "./ClientDashboard";

class RoleCheckDashboard extends React.Component {
    render() {
        if(!this.props.role) {
            //throw new Error('Redirect RoleCheck Error');
            //return <Redirect to="/login" />
        }

        if ((this.props.role || "").toLowerCase() === 'client')
            return (<ClientDashboard />);
        else
            return (<Dashboard />);
    }
}

const mapStateToProps = (state) => ({ role: state.user.role.role1 })

export default connect(mapStateToProps)(RoleCheckDashboard);